import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { DsToasts } from '@platform-workspace/design-system-v2';
import { RootAttributeService } from '@shared/data-access';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, DsToasts],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  providers: [RootAttributeService],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit {
  private readonly rootAttributeService = inject(RootAttributeService);

  ngOnInit(): void {
    this.rootAttributeService.initBodyVersion();
  }
}
